// store/geoFenceThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setAllLocationRanges } from "./geoFenceSlice";
import axios from "axios";


export const fetchGeoFences = createAsyncThunk(
  "geoFence/fetchGeoFences",
  async (_, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        "https://v3.dhundhoo.com/thing/getGeoFence",
        {}, 
        { headers: { "x-dhundhoo-session": token } }
      );
      const data = response.data;
      dispatch(setAllLocationRanges(data));

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

